import React, { useState } from 'react';
import { X, MapPin, Package } from 'lucide-react';
import LimaDeliveryForm from './LimaDeliveryForm';
import ProvinciaDeliveryForm from './ProvinciaDeliveryForm';

function DeliveryModal({ userId, cart, onClose, onSuccess }) {
  const [deliveryType, setDeliveryType] = useState(null); // null, 'lima', or 'provincia'

  function handleBackToSelection() {
    setDeliveryType(null);
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="bg-brand-primary text-white p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Package className="w-6 h-6" />
            <h2 className="text-2xl font-bold font-montserrat">
              {deliveryType === null ? 'Tipo de Envío' : 'Datos de Entrega'}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-white/20 rounded-lg transition-colors"
            aria-label="Cerrar"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-5rem)]">
          {deliveryType === null ? (
            <DeliveryTypeSelection onSelect={setDeliveryType} />
          ) : deliveryType === 'lima' ? (
            <LimaDeliveryForm
              userId={userId}
              cart={cart}
              onBack={handleBackToSelection}
              onSuccess={onSuccess}
            />
          ) : (
            <ProvinciaDeliveryForm
              userId={userId}
              cart={cart}
              onBack={handleBackToSelection}
              onSuccess={onSuccess}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function DeliveryTypeSelection({ onSelect }) {
  return (
    <div className="space-y-4">
      <p className="text-slate-600 font-montserrat text-center mb-6">
        Selecciona el tipo de envío para tu pedido
      </p>

      <div className="grid md:grid-cols-2 gap-4">
        <button
          onClick={() => onSelect('lima')}
          className="group relative bg-gradient-to-br from-brand-primary to-brand-primary/80 hover:from-brand-primary/90 hover:to-brand-primary text-white rounded-xl p-8 transition-all shadow-lg hover:shadow-2xl transform hover:-translate-y-1"
        >
          <div className="flex flex-col items-center text-center">
            <MapPin className="w-16 h-16 mb-4" />
            <h3 className="text-2xl font-bold font-montserrat mb-2">Lima</h3>
            <p className="text-sm opacity-90 font-montserrat">
              Entrega en Lima Metropolitana
            </p>
            <p className="text-xs opacity-75 font-montserrat mt-2">
              Pago contra entrega
            </p>
          </div>
        </button>

        <button
          onClick={() => onSelect('provincia')}
          className="group relative bg-gradient-to-br from-brand-gold to-brand-gold/80 hover:from-brand-gold/90 hover:to-brand-gold text-white rounded-xl p-8 transition-all shadow-lg hover:shadow-2xl transform hover:-translate-y-1"
        >
          <div className="flex flex-col items-center text-center">
            <Package className="w-16 h-16 mb-4" />
            <h3 className="text-2xl font-bold font-montserrat mb-2">Provincia</h3>
            <p className="text-sm opacity-90 font-montserrat">
              Envío a todo el Perú
            </p>
            <p className="text-xs opacity-75 font-montserrat mt-2">
              Pago anticipado requerido
            </p>
          </div>
        </button>
      </div>
    </div>
  );
}

export default DeliveryModal;